// Dummy data for Ledger Transactions screen

export const MOCK_LEDGER_TRANSACTIONS = [
  {
    sNo: 1,
    date: "01-Aug-2026",
    voucherNo: "BP-0001",
    voucherType: "Payment",
    typeColor: "#d97706",
    particulars: "ABC Suppliers",
    narration: "OPENING BAL ABC Suppliers",
    hasOpeningTag: true,
    referenceNo: "INV-4587",
    debit: 0,
    credit: 250000.0,
    balance: 195000.0,
    balanceType: "Dr",
  },
  {
    sNo: 2,
    date: "03-Aug-2026",
    voucherNo: "RC-0005",
    voucherType: "Receipt",
    typeColor: "#2563eb",
    particulars: "XYZ Customer",
    narration: "Payment received for invoice XYZ-104",
    referenceNo: "RTGS/12345",
    debit: 500000.0,
    credit: 0,
    balance: 695000.0,
    balanceType: "Dr",
  },
  {
    sNo: 3,
    date: "05-Aug-2026",
    voucherNo: "BP-0002",
    voucherType: "Payment",
    typeColor: "#d97706",
    particulars: "Office Rent",
    narration: "Office rent for August 2026",
    referenceNo: "NEFT/66521",
    debit: 0,
    credit: 100000.0,
    balance: 595000.0,
    balanceType: "Dr",
  },
  {
    sNo: 4,
    date: "07-Aug-2026",
    voucherNo: "BP-0003",
    voucherType: "Payment",
    typeColor: "#d97706",
    particulars: "Utility Expenses",
    narration: "Electricity and internet bill payment",
    referenceNo: "UPI/77891",
    debit: 0,
    credit: 25000.0,
    balance: 570000.0,
    balanceType: "Dr",
  },
  {
    sNo: 5,
    date: "10-Aug-2026",
    voucherNo: "RC-0006",
    voucherType: "Receipt",
    typeColor: "#2563eb",
    particulars: "DEF Customer",
    narration: "Advance against tour booking DEF-88",
    referenceNo: "NEFT/88912",
    debit: 375000.0,
    credit: 0,
    balance: 945000.0,
    balanceType: "Dr",
  },
  {
    sNo: 6,
    date: "12-Aug-2026",
    voucherNo: "BP-0004",
    voucherType: "Payment",
    typeColor: "#d97706",
    particulars: "Salary Payment",
    narration: "Monthly staff salary disbursement",
    referenceNo: "SAL/0826",
    debit: 0,
    credit: 410000.0,
    balance: 535000.0,
    balanceType: "Dr",
  },
  {
    sNo: 7,
    date: "16-Aug-2026",
    voucherNo: "RC-0007",
    voucherType: "Receipt",
    typeColor: "#2563eb",
    particulars: "GHI Customer",
    narration: "Receipt towards package billing",
    referenceNo: "RTGS/99123",
    debit: 250000.0,
    credit: 0,
    balance: 785000.0,
    balanceType: "Dr",
  },
  {
    sNo: 8,
    date: "18-Aug-2026",
    voucherNo: "BP-0005",
    voucherType: "Payment",
    typeColor: "#d97706",
    particulars: "Purchase - Raw Material",
    narration: "Material procurement settlement",
    referenceNo: "INV-7845",
    debit: 0,
    credit: 320000.0,
    balance: 465000.0,
    balanceType: "Dr",
  },
  {
    sNo: 9,
    date: "22-Aug-2026",
    voucherNo: "RC-0008",
    voucherType: "Receipt",
    typeColor: "#2563eb",
    particulars: "Misc. Income",
    narration: "Commission and foreign exchange differential",
    referenceNo: "MISC/0326",
    debit: 100000.0,
    credit: 0,
    balance: 565000.0,
    balanceType: "Dr",
  },
  {
    sNo: 10,
    date: "25-Aug-2026",
    voucherNo: "BP-0006",
    voucherType: "Payment",
    typeColor: "#d97706",
    particulars: "Vendor Payment",
    narration: "Payment to vendor towards transport fleet services",
    referenceNo: "NEFT/55221",
    debit: 0,
    credit: 250000.0,
    balance: 315000.0,
    balanceType: "Dr",
  },
  {
    sNo: 11,
    date: "28-Aug-2026",
    voucherNo: "RC-0009",
    voucherType: "Receipt",
    typeColor: "#2563eb",
    particulars: "JKL Customer",
    narration: "Settlement of final balance for luxury package",
    referenceNo: "RTGS/66112",
    debit: 400000.0,
    credit: 0,
    balance: 715000.0,
    balanceType: "Dr",
  },
  {
    sNo: 12,
    date: "30-Aug-2026",
    voucherNo: "BP-0007",
    voucherType: "Payment",
    typeColor: "#d97706",
    particulars: "Office Expenses",
    narration: "Stationery, pantry and monthly courier expenses",
    referenceNo: "CASH/0826",
    debit: 0,
    credit: 55000.0,
    balance: 660000.0,
    balanceType: "Dr",
  },
];

export const MOCK_LEDGER_METADATA = {
  accountName: "HDFC Bank A/c (110100)",
  accountCode: "110100",
  month: "Aug 2026",
  group: "Bank Accounts",
  type: "Asset",
  openingBalance: 445000.0,
  openingBalanceType: "Dr",
  totalDebit: 1625000.0,
  totalCredit: 1410000.0,
  closingBalance: 660000.0,
  closingBalanceType: "Dr",
  asOnTime: "08-Sep-2026 12:15 PM",
};

export const formatINR = (val) => {
  if (val === null || val === undefined || isNaN(val) || Number(val) === 0) return "";
  return Number(val).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
